/**
 * @desc 分页查询佣金统计列表
 */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {}

export function request(data: defs.PageRequest<defs.CommissionManagementPagingQueryParameters>): Promise<BaseResponse<defs.PageBean<Array<defs.CommissionManagement>>>> {
  return fetch({
    url: config.API_HOST + '/stat/pageList',
    data: data,
    method: 'POST',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
